import CustomSlider from '@components/CustomSlider/CustomSlider';
import styles from './ImageSizeContent.module.scss'
import Button from '@components/Button';
import { WheelEvent } from 'react';

export interface ImageSizeContentProps {
  value: number;
  onChangeValue: (val: number) => void;
  onReset: ()=>void;
  onClose: () => void;
}

const ImageSizeContent: React.FC<ImageSizeContentProps> = ({
  value,
  onChangeValue,
  onReset,
  onClose
}) => {
  return (
    <div className={styles['Container']}>
      <div className={styles['Box1']}>
        ImageSize
        <Button
          className={styles.resetButton}
          onClick={onReset}
        >
          Reset
        </Button>
      </div>
      <div className={styles['Box2']}
      onWheel={(e:WheelEvent)=>{
        if (e.deltaY === 0) return;
        const newVal = Math.min(240.0,Math.max(100.0,value+Math.sign(-e.deltaY)*5.0));
        onChangeValue(newVal);
      }}
      >
        <CustomSlider
          type="default"
          value={value}
          onChange={onChangeValue}
          min={100}
          max={240.0}
          step={5.0}
        />
        <div className={styles['value']}>
          {value}
        </div>
      </div>
    </div>
  )
}

export default ImageSizeContent;
